module.exports = __webpack_public_path__ + "img/infulacing-child-iq.67bca74.jpg";